import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'

export const MigrationDialogs = ({
  confirmOpen,
  reasons,
  isPending,
  onCancel,
  onConfirm,
  onCloseReasons,
}: {
  confirmOpen: boolean
  reasons: string[]
  isPending: boolean
  onCancel: () => void
  onConfirm: () => void
  onCloseReasons: () => void
}) => (
  <>
    <Dialog
      open={confirmOpen}
      onClose={isPending ? undefined : onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        このひな形をweb版の記録アプリで利用できる新しいひな形に変更しますか？
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          移行後は新しいひな形が作成されます。取り込み項目が設定されている場合、その項目は移行されず、新しいひな形には含まれません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isPending} onClick={onCancel}>
          変更しない
        </Button>
        <Button
          variant="contained"
          disabled={isPending}
          onClick={onConfirm}
          startIcon={isPending ? <CircularProgress size="1em" /> : undefined}
        >
          {isPending ? '変更中…' : '変更する'}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={reasons.length > 0}
      onClose={onCloseReasons}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>このひな形は移行できません</DialogTitle>
      <DialogContent>
        <List disablePadding>
          {reasons.map(reason => (
            <ListItem key={reason} disableGutters>
              <ListItemText primary={reason} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onCloseReasons}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  </>
)
